export const SP_TRANS = {
  submit: "Enviar",
  writeHere: "Escribe aqui..",
  pleaseAnswerThisQuestion: "Por favor responde esta pregunta",
};

export default SP_TRANS;